import { Button, FluentProvider, Text, Tooltip } from "@fluentui/react-components";
import { PersonAddRegular } from "@fluentui/react-icons";
import * as React from "react";
import { useRef } from "react";
import { setMemberDialogOpen, setMemberOpenDialogTriggerButton } from "sh-application/components/memberEditor/lib";
import { setMemberPanelValues } from "sh-application/components/schedules/lib";
import schedulesViewStateStore from "sh-application/components/schedules/lib/store/store";
import ThemeUtils from "sh-application/utility/ThemeUtils";
import { InstrumentationService } from "sh-services";
import StringsStore from "sh-strings/store";

const styles = require("./EmptyGroupSetup.scss");

interface EmptyGroupSetupProps {
    tagId: string;
}

const EmptyGroupSetup = ({tagId}: EmptyGroupSetupProps) => {

    const _strings = StringsStore().registeredStringModules.get("schedulePage").strings;
    const buttonRef = useRef(null);

    const handleClick = () => {
        setMemberDialogOpen(true);
        setMemberOpenDialogTriggerButton(buttonRef.current ?? null);
        setMemberPanelValues(schedulesViewStateStore(), tagId, null);

        InstrumentationService.logEvent(InstrumentationService.events.AddMembersClickedInEmptyGroupState, []);
    };
    return (
        <FluentProvider theme={ThemeUtils.getFluentV2ShiftTheme()}>
            <div className={styles.emptyGroupContainer} data-testid="emptyGroupSetup">
                <Text
                    font="base"
                    size={200}
                    weight="regular"
                >
                    {_strings.get("emptyGroupSetupTitle")}
                </Text>
                <Tooltip content={_strings.get("addMemberLabel")} relationship="description" positioning="above">
                    <Button
                        icon={
                            <PersonAddRegular
                                fontWeight="regular"
                            />
                        }
                        appearance="secondary"
                        onClick={handleClick}
                        ref={buttonRef}
                    >
                        {_strings.get("addMembersTitle")}
                    </Button>
                </Tooltip>
            </div>
        </FluentProvider>
    );
};

export default EmptyGroupSetup;